import { render } from "./OrdersLogs.vue?vue&type=template&id=3b7e8d8a"
import script from "./OrdersLogs.vue?vue&type=script&lang=js"
export * from "./OrdersLogs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/logs/OrdersLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b7e8d8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b7e8d8a', __exports__)) {
    console.log('reload')
    api.reload('3b7e8d8a', __exports__)
  }
  
  module.hot.accept("./OrdersLogs.vue?vue&type=template&id=3b7e8d8a", () => {
    console.log('re-render')
    api.rerender('3b7e8d8a', render)
  })

}


export default __exports__